// src/hooks/usePages.js
import { useState } from 'react';
import { API_BASE } from '../api/config';

export const usePages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadPages = async () => {
    try {
      const res = await fetch(`${API_BASE}/pages.php`, { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        setPages(data);
      } else {
        alert('获取页面列表失败');
      }
    } catch (err) {
      console.error('加载页面失败:', err);
    }
  };

  const savePage = async (title, components, id = null) => {
    setLoading(true);
    try {
      const pageData = { title, components };
      let url = `${API_BASE}/pages.php`;
      let method = 'POST';
      if (id) {
        url += `/${id}`;
        method = 'PUT';
      }
      const res = await fetch(url, {
        method,
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(pageData)
      });
      if (!res.ok) throw new Error(id ? '更新失败' : '创建失败');
      await loadPages();
      return true;
    } catch (err) {
      console.error('保存失败:', err);
      alert(err.message || '保存失败');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const deletePage = async (id) => {
    try {
      const res = await fetch(`${API_BASE}/pages.php/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (res.ok) {
        setPages(pages.filter(p => p.id !== id));
        return true;
      } else {
        alert('删除失败');
        return false;
      }
    } catch (err) {
      console.error('删除失败:', err);
      alert('网络错误');
      return false;
    }
  };

  return { pages, loadPages, savePage, deletePage, loading };
};